<template>
  <div class="checkManager-wrap">
    <h1>已为您匹配到以下客户经理，请选择(最多3位)</h1>
    <div class="mt100" >
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        >
          <van-checkbox-group max="3" v-model="result" v-for="(item, index) in listData" :key="index" >
            <van-checkbox :name="item">
              <template  #icon="props">
                <div class="checkbox-flex">
                  <div class="myorder-manager">
                    <van-image
                      round
                      :src="item.head_avatar"
                    />
                    <div class="manager-info">
                      <p @click="chatOnline">{{item.name}} 在线聊天</p>
                      <p class="ellipsis">{{item.position}}丨{{item.company}}</p>
                      <p><van-rate  class="manager-rate" color="#FF4B4D" void-color="#ddd" :allow-half="true" readonly v-model="item.score" size="15"/><em>{{item.score}}</em>({{item.done_number}}单)</p>
                    </div>
                  </div>
                </div>
                <van-button v-if="!props.checked" type="default" size="small" plain round>选我</van-button>
                <van-button v-else type="default" color="#0294FF" class="managersCheckbtn" size="small" plain round>已选</van-button>
              </template>
            </van-checkbox>
          </van-checkbox-group>
        </van-list> 
      </van-pull-refresh>
    </div>
    <div class="btn-fixed2">
      <van-button type="default" @click="handleSkip" block>跳过</van-button>
      <van-button type="info" color="#0294FF" @click="handleCheckManagers" block>确认</van-button>
    </div>
  </div>
</template>
<script>
import { Checkbox, CheckboxGroup, Button, Image as VanImage, Rate, Toast, Dialog, List, PullRefresh } from 'vant';
import { mapActions } from 'vuex';
export default {
  data() {
    return {
      result: [],
      checked: true,
      activeIcon: '',
      inactiveIcon: '',
      rateData: 2.5,
      listData: [],
      loading: false,
      finished: false,
      currentPage: 0,
      isLoading: false
    }
  },
  methods: {
    ...mapActions(['commitData', 'fetchRecord']),
    chatOnline() {
      if(!!window.Android) {
        window.Android.openChatSession('t_accid_00000000004')
      }
    },
    handleCheckManagers() {
      // console.log(this.managers)
      if(this.result.length > 0 && this.result.length < 4) {
         Dialog.alert({
          title: `已选${this.result.length}位客户经理`,
          message: '谢谢您的信任，我们将马上向您致电，请保持电话畅通。',
          theme: 'round-button',
          confirmButtonText: '好的，我会保持电话畅通',
          confirmButtonColor: '#0294FF',
          className: 'dialog-selectkhjl',
          width: '75%'
        }).then(() => {
          Toast.loading({
            message: '加载中...',
            forbidClick: true,
            loadingType: 'spinner',
          });
          const channel_lable = window.localStorage.getItem('channel')
          const loanParams = JSON.parse(window.localStorage.getItem('loanParams'))
          const loanPriceData = JSON.parse(window.localStorage.getItem('loanPriceData'))
          const baseInfoData = JSON.parse(window.localStorage.getItem('baseInfoData'))
          const subParam = Object.assign({}, loanParams, loanPriceData, baseInfoData, {channel_id: channel_lable})
          subParam.city_name = baseInfoData.provcity
          subParam.phone = subParam.phone ? subParam.phone : ''
          subParam.managers = this.result.map(a=> a.id).toString()
          this.commitData({
            request: 'loan/addinfo',
            path: 'loan/addinfo',
            data: subParam,
            onSuccess: (res) => {
              
              this.$router.push('/applysuccess?channel_lable='+channel_lable)
            },
            onFail: (err) => {
              this.$toast(err.msg)
            }
          });
        });
      } else if(this.result.length > 3) {
        this.$toast('最多3位')
      } else {
        this.$toast('请选择客户经理')
      }
    },
    handleSkip() {
      Dialog.confirm({
        message: '跳过后平台将让客户经理通过抢单方式联系您，确认跳过？',
        confirmButtonColor: '#0294FF',
        className: 'skip-dialog'
      })
      .then(() => {
        Toast.loading({
          message: '加载中...',
          forbidClick: true,
          loadingType: 'spinner',
        });
        const channel_lable = window.localStorage.getItem('channel')
        const loanParams = JSON.parse(window.localStorage.getItem('loanParams'))
        const loanPriceData = JSON.parse(window.localStorage.getItem('loanPriceData'))
        const baseInfoData = JSON.parse(window.localStorage.getItem('baseInfoData'))
        const subParam = Object.assign({}, loanParams, loanPriceData, baseInfoData, {channel_lable: channel_lable, managers: ''})
        subParam.city_name = baseInfoData.provcity
        subParam.phone = subParam.phone ? subParam.phone : ''
        this.commitData({
          request: 'loan/addinfo',
          path: 'loan/addinfo',
          data: subParam,
          onSuccess: (res) => {
            
            this.$router.push('/applysuccess?channel_lable='+channel_lable)
          },
          onFail: (err) => {
            this.$toast(err.msg)
          }
        });
      })
      .catch(() => {
        // on cancel
      })
    },
    onLoad() {
      setTimeout(() => {
        this.reloadList() 
      }, 500);
    },
    onRefresh() {       
      //下拉刷新
      setTimeout(() => {
        this.finished = false;
        this.isLoading  = false;
        this.listData = []
        this.currentPage = 0
        this.result = []
        this.reloadList() 
      }, 500);
    },
    reloadList() {
      this.currentPage += 1
      const channel_lable = window.localStorage.getItem('channel')
      const loanParams = JSON.parse(window.localStorage.getItem('loanParams'))
      const loanPriceData = JSON.parse(window.localStorage.getItem('loanPriceData'))
      const baseInfoData = JSON.parse(window.localStorage.getItem('baseInfoData'))
      const subParam = Object.assign({}, loanParams, loanPriceData, baseInfoData, {channel_id: channel_lable})
      subParam.city_name = baseInfoData.provcity
      subParam.phone = subParam.phone ? subParam.phone : ''
      this.fetchRecord({
        request: 'loan/getmanagers',
        path: 'loan/getmanagers',
        data: Object.assign({}, subParam, {
          currentPage: this.currentPage,
          pageSize: 15
        }),
        onSuccess: (res) => {
          this.loading = false
          if(res.info.length < 1){
            this.finished = true;
          }else{
            this.listData.push(...res.info)
            this.listData = this.listData.map(a=> {
              a.score =  Number(a.score)
              return a
            })
          }
        }
      })
    },
    conversion() {
      countLog.ready(function() { 
        countLog.init(function() {
        // 如果需要跳转，在此处写入 window.location.href = 跳转链接 
        }, {
          // 是否需要复制订单号，是为 1，不是为 0 
          isCopy: 0, 
          // 上报转化类型，具体见下表 
          pageType: 0 
      })})
    }
  },
  components: {
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Button.name]: Button,
    [VanImage.name]: VanImage,
    [Rate.name]: Rate,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
  },

}
</script>